import { Component, OnInit } from "@angular/core";
import { EvolucaoTarifariaService } from "../../providers/evolucao-tarifaria.service";

class Periodo {
  id: number;
  ano: number;
  tarifa_a_valor: number | string;
  tarifa_b_valor: number | string;
  tarifa_c_valor: number | string;
  tarifa_a_variacao: number | string;
  tarifa_b_variacao: number | string;
  tarifa_c_variacao: number | string;
}

@Component({
  selector: "app-evolucao-tarifaria",
  templateUrl: "./template.html",
  styleUrls: ["./styles.scss"],
})
export class EvolucaoTarifariaComponent implements OnInit {
  anosRange: Array<number> = [];
  periodos: Array<Periodo> = [];

  constructor(private evolucaoTarifariaService: EvolucaoTarifariaService) {}

  setAnosRange() {
    const periodsLength = this.periodos.length;
    this.anosRange = [
      this.periodos[0].ano,
      this.periodos[periodsLength - 1].ano,
    ];
  }

  fetchPeriodos() {
    this.evolucaoTarifariaService.getAll().subscribe(
      (result) => {
        this.periodos = result.map((p) => {
          const periodo = new Periodo();
          Object.keys(p).forEach((key) => {
            periodo[key] = p[key];
          });
          return periodo;
        });
        this.setAnosRange();
      },
      (error) => {
        console.error("Erro ao listar dados de evolução tarifária", error);
      }
    );
  }

  ngOnInit(): void {
    this.fetchPeriodos();
  }
}
